import { useEffect } from 'react';

export const useHotSpotTransformOldToNew = ({
  hotSpots,
  id,
  children,
  getNextHotSpotBlock,
  getBlockById,
  setNewBlockNewTree,
  store,
  setBlocksAction,
}) => {
  return useEffect(() => {
    if (!hotSpots) {
      return;
    }

    // note :
    // the goal here is to update the points on props to match
    // what we get from the hotSpots.points
    //
    // if we get errors we can compare the values
    // go to the projects blocks directly and remove the ' zombie ' points on the props ( look for hotSpotName )
    // then when this runs again it should update
    // or. since we have the values off hotSpots.points we can update the props.points with those values

    const someHotspotsUpdated = children.some(child => {
      const { updated } = child.props; //hotSpot?.props;

      return updated;
    });

    // if any of the hotSpots have been updated we can return
    //
    if (someHotspotsUpdated) {
      return;
    }

    const [newBlock, newTree] = getNextHotSpotBlock(getBlockById(id))!;

    if (newBlock && newBlock.children) {
      const hotSpotPoints = Object.values(hotSpots);

      (newBlock.children as []).forEach((child: any, index) => {
        // somewhere in here check for no content maybe ?
        // no. just ensure there's no diff between names / points ( length ) and children.length ?
        const hotSpot = getBlockById(child.id) as any;

        const { name } = hotSpot?.props;

        if (name) {
          // can't use hotSpots[name] since there's potentially dupes
          // hotSpots[name] ? hotSpots[name] : [];

          hotSpot.props.points = hotSpotPoints[index] || [];
        }
      });
    }

    // we were removing the hotSpots prop in the old case. DO NOT DO THAT !!!!
    // we'll keep them to aid in debugging later if it comes to that

    setNewBlockNewTree(newTree, newBlock, store, setBlocksAction);
  }, []);
};
